import cx from 'classnames';
import {isEmpty, isInteger, map, some} from 'lodash';
import {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Tooltip} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {WorkingHoursInterval} from 'types';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.WORKING_HOURS.DAY_STATUS;

enum Status {
    Open = 'open',
    Closed = 'closed'
}

type Props = {
    intervals: WorkingHoursInterval[];
    className?: string;
    isSpecialDay?: boolean;
}

export const DayStatus: React.FC<Props> = ({intervals, isSpecialDay, className}) => {
    const {t} = useTranslation();
    const getIntervalDuration = useCallback((interval: WorkingHoursInterval): number => {
        if (!isInteger(interval?.from?.hours) || !isInteger(interval?.to?.hours)) {
            return 0;
        }

        return (interval.to.hours - interval.from.hours) * 60 + (interval.to.minutes - interval.from.minutes);
    }, []);

    const status: Status = useMemo(() => {
        const durations = map(intervals, getIntervalDuration);
        return !isEmpty(durations) && some(durations, (d) => d > 0) ? Status.Open : Status.Closed;
    }, [intervals, getIntervalDuration]);
    const header = useMemo(() => status === Status.Open ? t(T_KEYS.WORKING_DAY) : t(T_KEYS.NON_WORKING_DAY), [t, status]);

    return (
        <Tooltip header={header}>
            <div className={cx('tw-rounded-full tw-w-4 tw-h-4', className, {
                'tw-bg-primary': status === Status.Open,
                'tw-bg-default': status === Status.Closed && !isSpecialDay,
                'tw-bg-alert': status === Status.Closed && isSpecialDay
            })}
            />
        </Tooltip>
    );
};